export const guaranteeDateObject = (date) => {
    if (date instanceof Date) {
        return date;
    }

    return new Date(date);
};

export const buildDateFromISOString = (dateString) => {
    const dateObj = new Date();
    const dateArray = dateString.split('T')[0].split('-');
    dateObj.setFullYear(dateArray[0]);
    dateObj.setMonth(dateArray[1] - 1);
    dateObj.setDate(dateArray[2]);
    return dateObj;
};

export const getEndOfMonth = (date) => {
    if (!date) {
        return null;
    }

    const dateObj = guaranteeDateObject(date);

    return new Date(dateObj.getFullYear(), dateObj.getMonth() + 1, 0);
};

export const getEndOfQuarter = (date) => {
    if (!date) {
        return null;
    }

    const dateObj = guaranteeDateObject(date);
    const inceptionMonthNum = dateObj.getMonth();
    const inceptionYear = dateObj.getFullYear();
    let quaterEndDateObj;

    // Months 0,1,2
    if (inceptionMonthNum < 3) {
        quaterEndDateObj = new Date(`${inceptionYear}-03-31`);
    }
    // Months 3,4,5
    if (inceptionMonthNum < 6) {
        quaterEndDateObj = new Date(`${inceptionYear}-06-30`);
    }
    // Months 6,7,8
    if (inceptionMonthNum < 9) {
        quaterEndDateObj = new Date(`${inceptionYear}-09-30`);
    }
    // Months 9,10,11
    if (inceptionMonthNum < 12) {
        quaterEndDateObj = new Date(`${inceptionYear}-12-31`);
    }

    return quaterEndDateObj;
};

export const differenceInDays = (date1, date2) => {
    if (!(date1 && date2)) {
        return null;
    }

    const dateObj1 = guaranteeDateObject(date1);
    const dateObj2 = guaranteeDateObject(date2);

    const diffTime = Math.abs(dateObj1.getTime() - dateObj2.getTime());

    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

export const isExpectingMonthlyData = (inceptionDate) => {
    // card should act like it's expecting monthly data if inceptionDate is not provided
    if (!inceptionDate) return true;

    // constructing using Date.now() so that we can mock the current date in tests
    const today = new Date(Date.now());
    const endOfInceptionMonth = getEndOfMonth(inceptionDate);

    // check if the fund was released last month and it's before the 15th
    // check if the fund was released this month
    // do not expect monthly data if either is true
    return !(
        differenceInDays(endOfInceptionMonth, today) < 15 ||
        endOfInceptionMonth > today
    );
};

export const isExpectingQuarterlyData = (inceptionDate) => {
    // card should act like it's expecting quarterly if inceptionDate is not provided
    // That's to say the card should say that something went wrong, because it did.
    if (!inceptionDate) return true;

    // constructing using Date.now() so that we can mock the current date in tests
    const today = new Date(Date.now());
    const endOfInceptionQuarter = getEndOfQuarter(inceptionDate);

    // check if the fund was released last quarter and it's before the 15th
    // check if the fund was released this quarter
    // do not expect quarterly data if either is true
    return !(
        differenceInDays(endOfInceptionQuarter, today) < 15 ||
        endOfInceptionQuarter > today
    );
};

export const isExpectingFullYearData = (inceptionDate) => {
    // card should act like it's expecting full year data if inceptionDate is not provided
    // That's to say the card should say that something went wrong, because it did.
    if (!inceptionDate) return true;

    // constructing using Date.now() so that we can mock the current date in tests
    const currentYear = new Date(Date.now()).getFullYear();
    const inceptionYear = new Date(inceptionDate).getFullYear();

    // should only return true if a full complete year has passed since inception
    return currentYear - inceptionYear > 1;
};
